import {PageHeader} from "../../../../lib/src/components/content/PageHeader";
import { useApiCall, useApiEndpoint} from "../../../../lib/src/api";
import {config} from "../../config";
import {TussenOnsBroadcastCard} from "../../components/tussen-ons/TussenOnsBroadcastCard";
import {Button} from "@jane/lib/src/components/form/Button";
import {usePermissions} from "../../resources/PermissionsHook";
import {ContentContainer} from "../../../../lib/src/components/content/ContentContainer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import {NavLink, useParams} from "react-router-dom";
import {FC, useMemo} from "react";
import moment from "moment/moment";
import {faPaperclip} from "@fortawesome/pro-regular-svg-icons";

export const TussenOnsBroadcastDetailPage = () => {
  const {broadcastId} = useParams()
  const id = broadcastId ? parseInt(broadcastId) : null
  if (id) {
    return <TussenOnsBroadcastDetailPageContent broadcastId={id} />
  }
  return <div>...</div>
}

const TussenOnsBroadcastDetailPageContent: FC<{broadcastId: number}> = (props) => {
  const {broadcasts: broadcastsApi} = useApiCall(config)
  const {resource: broadcast, isLoading} = useApiEndpoint(() => broadcastsApi.readUserBroadcast(props.broadcastId))

  if (! broadcast) {
    return <div>Bericht niet gevonden</div>
  }

  return <ContentContainer size={'sm'}>
    <div className={'underline text-brand-primary cursor-pointer'} onClick={() => {window.history.go(-1)}}>Terug naar overzicht</div>
    {broadcast.cover_image_url ? <img src={broadcast.cover_image_url} alt="" className={'object-cover h-64 w-full rounded-lg mt-8 mb-8'} /> : <></>}
    <PageHeader>{broadcast.subject}</PageHeader>
    <div className={'text-brand-secondary text-xs -mt-6 mb-8'}>{moment(broadcast.updated_at).format('DD-MM-YYYY HH:mm')}</div>

    <div className={'mb-8'}>{broadcast.message}</div>

    {broadcast.attachment_url ? <>
      <Button type={'primary'} size={'sm'} icon={faPaperclip} text={`${broadcast.attachment_name}`} onClick={() => {
        window.open(broadcast.attachment_url!, '_blank')
      }} />
    </> : <></>}
  </ContentContainer>
}